import React from 'react';

const ExternalFinDocCompleted = ({admission}) => {
    const paymentBlock = () => {
        if (admission.externalPaymentCompleted) {
            return <div className="status-info-step status-info-step3 status-done">
                <div className="content">
                    <strong className="sub-heading d-block">Payment $ {admission.externalPaymentAmount}</strong>
                    <span className="d-block">Externally paid at {admission.externalPaymentDateTime}</span>
                </div>
            </div>

        } else {
            return <div className="status-info-step status-info-step3 status-done">
                <div className="content"><strong className="sub-heading d-block">No payment</strong></div>
            </div>
        }
    }

    return <div className="d-inline-flex align-items-center">
        <div className="status-info-holder bg-secondary rounded d-flex align-items-stretch">
            <div className="status-info-step status-info-step1 status-done documents-completed-outside">
                <div className="content"><strong className="sub-heading d-block">Completed outside of portal</strong></div>
                <svg className="arrow-shape" viewBox="0 0 24 64" version="1.1"
                     xmlns="http://www.w3.org/2000/svg">
                    <polyline points="0,0 3,0 22,32 3,64 0,64 0,0" fill="none" fill-rule="evenodd"
                              stroke="#ffffff" stroke-width="4px" stroke-linejoin="round"></polyline>
                    <polyline className="cover-line" points="0,0 19,32 0,64 0,0" fill="none" fill-rule="evenodd"
                              stroke="none" stroke-width="4px" stroke-linejoin="round"></polyline>
                </svg>
            </div>
            {paymentBlock()}
        </div>
    </div>
}

export default ExternalFinDocCompleted;